import gallery from "../data/Home/gallery";
import concept from "../data/Home/concept";
import promotion from "../data/Home/promotion";

const fetchGalleryApi = () => {
  return Promise.resolve(gallery);
};

const fetchConceptApi = () => {
  return Promise.resolve(concept);
};

const fetchPromotionApi = () => {
  return Promise.resolve(promotion);
}

export {
  fetchGalleryApi,
  fetchConceptApi,
  fetchPromotionApi
};



// WEBPACK FOOTER //
// ./src/services/home.js